import type { SocialNetworks } from '@/types';

import React from 'react';

import { Box, Flex, GridItem, Image, Link } from '@/components';

const SocialMedia: React.FC<{ socialNetworks: SocialNetworks }> = ({
  socialNetworks,
}) => {
  return (
    <>
      <Flex gap="25px" mt="35px" flexWrap="wrap">
        {socialNetworks.map((item) => (
          <GridItem key={item.id} width="max-content">
            <Link
              prefetch={false}
              display={'flex'}
              alignItems="center"
              href={item.link}
              target={'_blank'}
            >
              <Box
                borderRadius="50%"
                display="flex"
                alignItems="center"
                justifyContent="center"
              >
                <Image
                  src={item.icon}
                  alt={item.alt_icon}
                  width={40}
                  height={40}
                  style={{ width: 40, height: 40, objectFit: 'contain' }}
                />
              </Box>
            </Link>
          </GridItem>
        ))}
      </Flex>
    </>
  );
};

export default SocialMedia;
